import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import {Link} from 'react-router-dom';
import {
    Button,
    Breadcrumb,
    Loader,
    Dimmer,
    Table,
    Popup
} from 'semantic-ui-react';
import update from 'react-addons-update';

import CustomDivider from '../../components/extras/CustomDivider';
import MemberData from "../../data/MemberData";
import MainToolbar from "../../components/extras/MainToolbar";
import MemberDialog from "../../components/security/MemberDialog";
import PermissionsDialog from "../../components/security/PermissionsDialog";
import MemberEditDialog from "../../components/security/MemberEditDialog";
import MemberChangePassword from "../../components/security/MemberChangePassword";
import QuestionDialog from "../../components/extras/QuestionDialog";
import NoData from "../../components/extras/NoData";
import Toast from "../../components/extras/Toast";
import CheckPermission from "../../components/extras/CheckPermission";
import localDB from "../../data/localDB";
import AlertUpgrade from "../../components/extras/AlertUpgrade";

const C = require("../../constants");

class StoreUsers extends Component {

    constructor() {
        super();
        this.state = {
            data: {
                count: 0,
                next: "",
                previous: "",
                results: []
            },
            loading: true,
            page: 1,
            search: "",
            header: ['Usuario', 'Nombre Completo', 'Sucursal', 'Rol', 'Activo', 'Acciones'],
            store: localDB.get('store'),
            roles: C.USER_TYPES
        };
        this.initialFetch = this.initialFetch.bind(this);
        this.activeConfirm = this.activeConfirm.bind(this);
    }

    componentDidMount() {
        this.initialFetch("", 1);

        if(this.state.store.category == C.REPAIR_SHOP_CATEGORY){
            let roles = [...this.state.roles, ...C.REPAIR_SHOP_ROLES];
            this.setState({roles});
        }
    }

    openDialog = () => {
        if(this.state.data.results.length < localDB.get('plan_access').users || localDB.get('plan_access').users === 0){
            this.refs.dialog.updateLabels(null);
            this.refs.dialog.handleOpen();
        }else{
            this.refs.alert_upgrade.open();
        }
    };

    addData = (res) => {
        let oldData = this.state.data.results.slice();
        oldData.push(res);

        let data = update(this.state, {
            data: {
                results: {
                    $set: oldData
                }
            }
        });
        this.setState(data);
    };

    updateData = (res, index) => {
        let oldData = this.state.data.results.slice();
        oldData[index] = res;
        let data = update(this.state, {
            data: {
                results: {
                    $set: oldData
                }
            }
        });
        this.setState(data);
    };

    async initialFetch(search, page) {
        MemberData.list(search, page).then(data =>{
            if(!data.hasOwnProperty('detail')){
                if (this.state.page === 1) {
                    this.setState({data, loading: false});
                } else {
                    let oldData = this.state.data.results.slice();
                    let newData = update(this.state, {
                        data: {
                            results: {
                                $set: oldData.concat(data.results)
                            },
                            next: {
                                $set: data.next
                            }
                        }
                    });
                    this.setState(newData);
                }
            }
        });
    };

    handleSearch = (search) => {
        this.initialFetch(search, 1)
    };

    activeConfirm = (index) => {
        let member = this.state.data.results[index];
        MemberData.active({id: member.id, is_active: !member.user.is_active}, (res) => {
            if (res.update) {
                let oldData = this.state.data.results.slice();
                oldData[index].user.is_active = res.is_active;
                let data = update(this.state, {
                    data: {
                        results: {
                            $set: oldData
                        }
                    }
                });
                this.setState(data);
                this.refs.toast.show({message: res.message, type: 'success'});
            } else {
                this.refs.toast.show({message: res.message, type: 'error'});
            }
        });
    };

    editDialog = (index) => {
        this.refs.edit_dialog.handleOpen(this.state.data.results[index], index);
    };

    permissionsDialog = (index) => {
        this.refs.permissions_dialog.handleOpen(this.state.data.results[index], index);
    };

    passwordDialog = (user, id) => {
        this.refs.password_dialog.handleOpen(user, id);
    };

    loadMore = () => {
        let page = this.state.page + 1;
        let search = this.state.search;
        this.setState({page: page, search: search});
        this.initialFetch(search, page);
    };

    render() {
        let rows = this.state.data.results.length > 0 ? this.state.data.results.map(function (user, index) {
            return (
                <Table.Row key={user.user.id}>
                    <Table.Cell>{user.user.username}</Table.Cell>
                    <Table.Cell>{user.user.full_name}</Table.Cell>
                    <Table.Cell>{user.branch_office.name}</Table.Cell>
                    <Table.Cell>{this.state.roles.find(type => type.key === user.user.type).text}</Table.Cell>
                    <Table.Cell>{user.user.is_active ? 'Si' : 'No'}</Table.Cell>
                    <Table.Cell>
                        <Button.Group basic size='small'>
                            <Popup
                                trigger={<Button icon='pencil' onClick={() => this.editDialog(index)}/>}
                                content='Editar usuario'
                                size='tiny'
                            />
                            <Popup
                                trigger={
                                    <Button icon={`${user.user.is_active ? 'lock' : 'unlock'}`}
                                            onClick={() => this.refs.question_dialog.open(`${user.user.is_active ? 'bloquear' : 'activar'} este usuario`, index)}/>
                                }
                                content={`${user.user.is_active ? 'Bloquear' : 'Activar'} usuario`}
                                size='tiny'
                            />
                            <Popup
                                trigger={<Button icon='key' onClick={() => this.passwordDialog(user.user, user.id)}/>}
                                content='Cambiar contraseña'
                                size='tiny'
                            />
                            <Popup
                                trigger={<Button icon='detective' onClick={() => this.permissionsDialog(index)}/>}
                                content='Cambiar permisos'
                                size='tiny'
                            />
                        </Button.Group>
                    </Table.Cell>
                </Table.Row>
            )
        }, this) : <NoData colSpan={6}/>;

        let loadMore = <Table.Row>
            <Table.Cell colSpan={6}>
                <Button fluid onClick={() => this.loadMore()}>Cargar Más</Button>
            </Table.Cell>
        </Table.Row>;

        let header = this.state.header.map(function (header, i) {
            return (
                <Table.HeaderCell key={i}>
                    {header}
                </Table.HeaderCell>
            )
        }, this);

        let table = <Table celled>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell colSpan='6'>
                        <MainToolbar title="Usuarios" name="Usuario" ref="toolbar" icon="user" btnAdd={true}
                                     callbackAdd={this.openDialog} callbackSearch={this.handleSearch}/>
                    </Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Header>
                <Table.Row>
                    {header}
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {rows}
                {this.state.data.next ? loadMore : null}
            </Table.Body>
        </Table>;

        const progress = <Dimmer.Dimmable><Dimmer active inverted style={{background:'transparent'}}><Loader inline='centered'>Cargando</Loader></Dimmer></Dimmer.Dimmable>;

        return (
            <div>
                <Helmet>
                    <title>Usuarios | Seguridad - Quipuu</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/security'>Seguridad</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Usuarios</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                {this.state.loading ? progress : null}
                {this.state.loading ? null : table}

                <MemberDialog ref="dialog" callbackAddData={this.addData}/>
                <MemberEditDialog ref="edit_dialog" callbackAddData={this.addData}
                                  callbackUpdateData={this.updateData}/>
                <PermissionsDialog ref="permissions_dialog" callbackUpdateData={this.updateData}/>
                <MemberChangePassword ref="password_dialog" callbackUpdateData={this.updateData}/>
                <QuestionDialog ref='question_dialog' callbackConfirm={this.activeConfirm}/>
                <Toast ref='toast'/>
                <AlertUpgrade ref='alert_upgrade'/>
                <CheckPermission access='members_view'/>
            </div>
        );
    }
}

export default StoreUsers;



// WEBPACK FOOTER //
// ./src/containers/security/Members.js